module.exports = __webpack_public_path__ + "img/historyBg.21a8d5e2.png";